import { useEffect } from "react";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import Loader from "./Loader";
import { useInstalledCapicity } from "../hooks/useInstalledCapicity";

const Capacity = () => {
  const { getText } = useLanguageTranslation();
  const { totals, isLoading } = useInstalledCapicity();

  useEffect(() => {
    const animateNumbers = () => {
      document.querySelectorAll(".stat-number").forEach((element) => {
        const size = element.textContent.split(".")[1]
          ? element.textContent.split(".")[1].length
          : 0;
        const targetNumber = parseFloat(element.textContent);
        const duration = 6000;
        const start = 0;
        const range = targetNumber - start;
        let startTime = null;

        const animate = (currentTime) => {
          if (!startTime) startTime = currentTime;
          const progress = Math.min((currentTime - startTime) / duration, 1);
          element.textContent = (progress * range).toFixed(size);
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      });
    };

    if (totals) animateNumbers();
  }, [totals]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="counter-area">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 ">
              <ul>
                <li className="main-counter wow zoomIn">
                  <span className="numbring-sec">
                    <span className="stat-number number">
                      {/* {hydroPlantsTotal +
                        thermalPlantsTotal +
                        parseInt(solarPlantsTotal)} */}
                      {totals.total}
                    </span>
                    <span className="number-unit">
                      {getText("MW", "मेगावाट")}
                    </span>
                  </span>
                  <span className="text">
                    {getText(
                      "PRESENT INSTALLED CAPACITY",
                      "वर्तमान स्थापित क्षमता",
                    )}
                  </span>
                  <div className="frst-icon-li">
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/thunderbolt.png`}
                      alt={getText(
                        "Installed capacity icon",
                        "स्थापित क्षमता आइकन",
                      )}
                      className="counter-frst-icon"
                    />
                  </div>
                </li>
                <li className="wow zoomIn">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/hydro-power.png`}
                    alt={getText("Hydro power icon", "जल विद्युत आइकन")}
                    className="counter-icon"
                  />
                  <div className="counter-txt-sec">
                    <span className="numbring-sec">
                      <span className="stat-number number">
                        {/* {parseInt(hydroPlantsTotal)} */}
                        {totals.hydro}
                      </span>
                      <span className="number-unit">
                        {getText("MW", "मेगावाट")}
                      </span>
                    </span>
                    <span className="text">
                      {getText("Hydro Power", "जल विद्युत")}
                    </span>
                  </div>
                </li>
                <li className="wow zoomIn">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/industry.png`}
                    alt={getText("Thermal power icon", "ताप विद्युत आइकन")}
                    className="counter-icon"
                  />
                  <div className="counter-txt-sec">
                    <span className="numbring-sec">
                      <span className="stat-number number">
                        {/* {parseInt(thermalPlantsTotal)} */}
                        {totals.thermal}
                      </span>
                      <span className="number-unit">
                        {getText("MW", "मेगावाट")}
                      </span>
                    </span>
                    <span className="text">
                      {getText("Thermal Power", "ताप विद्युत")}
                    </span>
                  </div>
                </li>
                <li className="wow zoomIn">
                  <img
                    src={`${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/solar-panel.png`}
                    alt={getText(
                      "Renewable power icon",
                      "नवीकरणीय ऊर्जा आइकन",
                    )}
                    className="counter-icon"
                  />
                  <div className="counter-txt-sec">
                    <span className="numbring-sec">
                      <span className="stat-number number">
                        {/* {parseInt(solarPlantsTotal)} */}
                        {totals.solar}
                      </span>
                      <span className="number-unit">
                        {getText("MW", "मेगावाट")}
                      </span>
                    </span>
                    <span className="text">
                      {getText("Renewable Power", "नवीकरणीय ऊर्जा")}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Capacity;
